import {CircularProgress, InputAdornment} from '@material-ui/core';
import {Async, isLoaded, isLoading} from 'Core/models/Async';
import {Email, InvalidEmail, ValidEmail} from 'Core/models/Email';
import {Either, isLeft, isRight} from 'fp-ts/lib/Either';
import React, {useEffect, useState} from 'react';
import {Errors} from 'Shared/components/ErrorPopover';
import ValidatableTextField from 'Shared/components/ValidatableTextField';
import './ValidatableTextInput.sass';

export type ValidatableEmailInputProps = {
  value: Async<Either<Email, ValidEmail>>;
  onValidate: (email: string) => void;
  label: string;
  className?: string;
  disabled?: boolean;
};

const getEitherValue = <TLeft, TRight>(value: Either<TLeft, TRight>) => (isLeft(value) ? value.left : value.right);

const ValidatableEmailInput = (props: ValidatableEmailInputProps) => {
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const errors = isLoaded(props.value)
    ? Errors.standardErrors({
        value:
          isLeft(props.value.Data) && props.value.Data.left.address === ''
            ? ['Please supply a value.']
            : isLeft(props.value.Data) && props.value.Data.left instanceof InvalidEmail
            ? ['Invalid email address.']
            : isLeft(props.value.Data)
            ? ['Email is already taken.']
            : [],
      })
    : Errors.standardErrors({value: []});

  useEffect(() => {
    if (isLoaded(props.value) && getEitherValue(props.value.Data) instanceof ValidEmail) {
      setHasBeenBlurred(true);
    }
  }, [props.value]);

  return isLoaded(props.value) || isLoading(props.value) ? (
    <ValidatableTextField
      InputProps={{
        endAdornment: <InputAdornment position="end">{isLoading(props.value) && <CircularProgress />}</InputAdornment>,
      }}
      label={props.label}
      disabled={props.disabled}
      errors={errors}
      showErrors={errors => hasBeenBlurred && errors.value.length > 0}
      textInputClassName={`${isLoaded(props.value) && isRight(props.value.Data) && 'validatable-text-input'} ${
        props.className
      }`}
      onBlur={() => setHasBeenBlurred(true)}
      onChange={value => {
        props.onValidate(value);
      }}
      value={isLeft(props.value.Data!) ? props.value.Data.left.address : props.value.Data!.right.address}
    />
  ) : (
    <>An error has occurred.</>
  );
};

export default ValidatableEmailInput;
